import React, {useEffect, useState} from 'react';
import {getLastEventApi} from "../../../../api/AdminApi";
import Loading from "../../../../components/Site/Loading/Loading";
import Event from "../../../../components/Admin/event/Event";


const DashboardHome = () => {
    const [lastEventData, setLastEventData] = useState({})
    const getLastEvent = async () => {
        try {
            const res = await getLastEventApi()
            console.log(res?.data?.data, "kiki")
            setLastEventData(res?.data?.data)

        } catch (e) {

        }
    }

    useEffect(() => {
        getLastEvent()
    }, [])


    if (!lastEventData?.id) return <Loading/>
    return (
        <Event item={lastEventData}/>
    );
};

export default DashboardHome;